module.exports = __webpack_public_path__ + "static/bentonsanscond-black-webfont-0977d16969be986e0b1dc3ac6f221339.woff";